import { Utils } from "./Utils";
import { API } from "./API";

export class BookingForm {
  constructor() {
    this.form = document.querySelector("form");
    this.mode = this.determineMode();
    this.bookingId = this.getBookingId();
    this.booking = null;
    this.initialize();
	this.isSubmitting = false;
  }

  determineMode() {
    const path = window.location.pathname;

    if (path.endsWith("/create")) return "create";
    if (path.endsWith("/edit")) return "edit";
    return "view";
  }

  getBookingId() {
    const path = window.location.pathname;
    const matches = path.match(/\/booking\/(\d+)/);
    return matches ? matches[1] : null;
  }

  async initialize() {
    const queryParams = new URLSearchParams(window.location.search);

    if (this.mode === "create") {
      const bookingNumberElement = document.getElementById("bookingNumber");
      const dateElement = document.getElementById("bookingDate");

      bookingNumberElement.textContent = "Новая бронь";

      const today = new Date();
      const travelDate =
        queryParams.get("travel_date") || Utils.formatDate(today);
		
	  // travelDate
      const travelDateObj = new Date();

      const day = String(travelDateObj.getDate()).padStart(2, "0");
      const months = [
        "января",
        "февраля",
        "мрта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
      const month = months[today.getMonth()];
      const year = today.getFullYear();
      dateElement.textContent = `${day} ${month} ${year} г.`;

      document.getElementById("travelDate").value =
        this.formatDateForInput(travelDate);

      if (queryParams.has("boat")) {
        document.getElementById("boat").value = queryParams.get("boat");
		document.getElementById("upgrade").value = queryParams.get("boat");
      }
      if (queryParams.has("departure_time")) {
        document.getElementById("departureTime").value =
          queryParams.get("departure_time");
      }
    }

    if (this.mode === "edit" || this.mode === "view") {
      await this.loadBookingData();
    }

    if (this.mode === "view") {
      this.disableAllFields();
    } else {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
    }

    // Add event listeners for date and boat changes
    document.getElementById("travelDate").addEventListener("change", () => {
      this.updateBookingDate();
      this.updateAvailableSlots();
    });

    document
      .getElementById("boat")
      .addEventListener("change", () => this.updateAvailableSlots());

    // Initial update if we have date and boat (from URL params)
    if (this.mode === "create") {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has("travel_date") && queryParams.has("boat")) {
        await this.updateAvailableSlots();
      }
    }
  }

  formatDateForInput(dateString) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  }

  async loadBookingData() {
    try {
      const data = await API.getBooking(this.bookingId);
      if (data.success) {
        this.booking = data.booking;
        this.fillFormData(data.booking);
      } else {
        alert("Error loading booking data");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error loading booking data");
    }

    // Add event listener for travelDate change
    document.getElementById("travelDate").addEventListener("change", () => {
      this.updateBookingDate();
    });
  }

  fillFormData(booking) {
    const bookingNumberElement = document.getElementById("bookingNumber");
    const dateElement = document.getElementById("bookingDate");

    bookingNumberElement.textContent = `Бронь № ${booking.booking_number}`;

	// booking.travel_date
    const travelDate = new Date();
    const day = String(travelDate.getDate()).padStart(2, "0");
    const months = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    const month = months[travelDate.getMonth()];
    const year = travelDate.getFullYear();
    dateElement.textContent = `${day} ${month} ${year} г.`;

    if (this.mode === "view") {
      document.getElementById("source").value = booking.source;
      document.getElementById("boat").value = booking.boat;
      document.getElementById("upgrade").value = booking.upgrade;
      document.querySelector('input[type="checkbox"]').checked =
        booking.closed_for_brokers;
      document.getElementById("clientName").value = booking.client_name;
      document.getElementById("phone").value = booking.phone;
      document.getElementById("travelDate").value = this.formatDateForInput(
        booking.travel_date
      );
      document.getElementById("departureTime").value = booking.departure_time;
      document.getElementById("duration").value = booking.duration;
      document.getElementById("guests").value = booking.guests_count;
      document.getElementById("rentalCost").value = booking.rental_cost;
      document.getElementById("deposit").value = booking.deposit;
      document.getElementById("onboardPayment").value = booking.onboard_payment;
      document.getElementById("comments").value = booking.comments;

      this.disableAllFields();
    } else {
      document.getElementById("source").value = booking.source;
      document.getElementById("boat").value = booking.boat;
      document.getElementById("upgrade").value = booking.upgrade;
      document.querySelector('input[type="checkbox"]').checked =
        booking.closed_for_brokers;
      document.getElementById("clientName").value = booking.client_name;
      document.getElementById("phone").value = booking.phone;
      document.getElementById("travelDate").value = this.formatDateForInput(
        booking.travel_date
      );
      document.getElementById("departureTime").value = booking.departure_time;
      document.getElementById("duration").value = booking.duration;
      document.getElementById("guests").value = booking.guests_count;
      document.getElementById("rentalCost").value = booking.rental_cost;
      document.getElementById("deposit").value = booking.deposit;
      document.getElementById("onboardPayment").value = booking.onboard_payment;
      document.getElementById("comments").value = booking.comments;
    }

    this.updateAvailableSlots();
  }

  disableAllFields() {
    this.form.querySelectorAll("input, select, textarea").forEach((element) => {
      const value = element.value;
      const container = element.parentElement;

      const textDisplay = document.createElement("div");
      textDisplay.className = "py-2 text-[#203E99]";

      if (element.type === "checkbox") {
        textDisplay.textContent = element.checked ? "Да" : "Нет";
      } else {
        textDisplay.textContent = value || "—";
      }

      container.replaceChild(textDisplay, element);
    });

    const submitButton = this.form.querySelector('button[type="submit"]');
    const buttonContainer = submitButton.parentElement;

    const buttonsContainer = document.createElement("div");
    buttonsContainer.className = "flex gap-4 w-full";

    const editButton = document.createElement("button");
    editButton.className = "btn-primary w-full bg-[#203E99]";
    editButton.textContent = "РЕДАКТИРОВАТЬ";
    editButton.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = `/admin/booking/${this.bookingId}/edit`;
    });

    buttonsContainer.appendChild(editButton);

    buttonContainer.replaceChild(buttonsContainer, submitButton);
  }

  async handleSubmit(e) {
    e.preventDefault();
	
	if (this.isSubmitting) {
      return; 
    }
	
	this.isSubmitting = true;

    const travelDate = document.getElementById("travelDate").value;
	
	let from = '';
	if (document.getElementById("boat").value != document.getElementById("upgrade").value) {
		from = document.getElementById("boat").value;
	}else{
		if (this.mode !== "create") {
			const data = await API.getBooking(this.bookingId);
			if (data.success) {
				from = data.booking.from;
			}
		}
	}

    const formData = {
      source: document.getElementById("source").value,
      boat: document.getElementById("upgrade").value,
      upgrade: document.getElementById("upgrade").value,
	  from: from,
      closedForBrokers: document.querySelector('input[type="checkbox"]')
        .checked,
      clientName: document.getElementById("clientName").value,
      phone: document.getElementById("phone").value,
      travelDate,
      departureTime: document.getElementById("departureTime").value,
      duration: parseInt(document.getElementById("duration").value),
      guestsCount: parseInt(document.getElementById("guests").value),
      rentalCost: parseFloat(
        document.getElementById("rentalCost").value.replace(",", "")
      ),
      deposit: parseFloat(
        document.getElementById("deposit").value.replace(",", "")
      ),
      onboardPayment: parseFloat(
        document.getElementById("onboardPayment").value.replace(",", "")
      ),
      comments: document.getElementById("comments").value,
    };

    try {
      const data =
        this.mode === "create"
          ? await API.createBooking(formData)
          : await API.updateBooking(this.bookingId, formData);

      if (data.success) {
        alert(
          this.mode === "create"
            ? "Бронирование успешно создано!"
            : "Бронирование успешно обновлено!"
        );		
		const d = travelDate + ' 12:00:00';
        localStorage.setItem("selectedDate", d);
        window.location.href = "/admin/";
      } else {
        alert(`Ошибка: ${data.error}`);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Произошла ошибка при отправке формы");
    } finally {
      this.isSubmitting = false;
    }
  }

  async updateAvailableSlots() {
    const bookingId = this.bookingId;
    const travelDate = document.getElementById("travelDate").value;
    const boat = document.getElementById("boat").value;

    try {
      const data = await API.getAvailableSlots(travelDate, boat, bookingId);
      if (data?.success) {
        this.updateTimeSelects(data.slots);
      }
    } catch (error) {
      console.error("Error fetching available slots:", error);
    }
  }

  updateTimeSelects(slots) {
	  console.log(slots);
    const departureTimeSelect = document.getElementById("departureTime");
    const durationSelect = document.getElementById("duration");
    const queryParams = new URLSearchParams(window.location.search);
    const presetTime =
      queryParams.get("departure_time") ?? this.booking?.departure_time;
    const presetDuration = this.booking?.duration; // Get preset duration from booking if available

    // Clear and disable duration select
    durationSelect.innerHTML =
      '<option value="">Выберите время выезда</option>';
    durationSelect.disabled = true;

    // Update departure time options
    departureTimeSelect.innerHTML = '<option value="">Выберите время</option>';

    let presetTimeAvailable = false;
    let presetTimeOption = null;

    slots.forEach((slot) => {
      if (slot.available) {
        const option = document.createElement("option");
        const timeValue = `${slot.hour.toString()}`;
        option.value = timeValue;
        option.textContent = timeValue;
        option.dataset.maxDuration = slot.maxDuration;
        departureTimeSelect.appendChild(option);

        // Check if this slot matches the preset time
        if (presetTime === timeValue) {
          presetTimeAvailable = true;
          presetTimeOption = option;
        }
      }
    });

    // If we have a preset time and it's available, select it and update duration options
    if (presetTimeAvailable && presetTimeOption) {
      departureTimeSelect.value = presetTime;

      // Update duration options
      const maxDuration = parseInt(presetTimeOption.dataset.maxDuration);
      durationSelect.innerHTML = "";
      for (let i = 1; i <= maxDuration; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = `${i} ${this.getHourWord(i)}`;
        durationSelect.appendChild(option);
      }
      durationSelect.disabled = false;

      // Set preset duration if available and within maxDuration
      if (presetDuration && presetDuration <= maxDuration) {
        durationSelect.value = presetDuration;
      }
    }

    // Add event listener to departure time select
    departureTimeSelect.addEventListener("change", () => {
      const selectedOption = departureTimeSelect.selectedOptions[0];
      if (!selectedOption.value) {
        durationSelect.innerHTML =
          '<option value="">Выберите время выезда</option>';
        durationSelect.disabled = true;
        return;
      }

      const maxDuration = parseInt(selectedOption.dataset.maxDuration);

      // Update duration options
      durationSelect.innerHTML = "";
      for (let i = 1; i <= maxDuration; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = `${i} ${this.getHourWord(i)}`;
        durationSelect.appendChild(option);
      }
      durationSelect.disabled = false;

      // Reset duration selection if it exceeds maxDuration
      if (parseInt(durationSelect.value) > maxDuration) {
        durationSelect.value = "";
      }
    });
  }

  getHourWord(hours) {
    if (hours === 1) return "час";
    if (hours >= 2 && hours <= 4) return "часа";
    return "часов";
  }

  updateBookingDate() {
    const travelDate = document.getElementById("travelDate").value;
    const travelDateObj = new Date();
    const day = String(travelDateObj.getDate()).padStart(2, "0");
    const months = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    const month = months[travelDateObj.getMonth()];
    const year = travelDateObj.getFullYear();
    document.getElementById(
      "bookingDate"
    ).textContent = `${day} ${month} ${year} г.`;
  }
}
